






import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "ErrorLabel",
  props: {
    text: { type: String, default: "" },
  },
});
